'use strict'
module.exports = {
  NODE_ENV: '"production"',
//   rootPath: '"https://hynds-travel-points.72dpi.net.nz"', // dev site
  rootPath: '"https://www.hyndsvip.co.nz"',
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 1